import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Chip from '@mui/material/Chip'
import CloseIcon from '@mui/icons-material/Close'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { DateTime } from 'luxon'

export const ErrorDialog = ({ open, onClose, process, isAdmin }) => {
  const allErrors = process?.retryErrors || []
  const lastReprocessedAt = process?.lastReprocessedAt
    ? new Date(process.lastReprocessedAt)
    : null

  const errors = (!isAdmin && lastReprocessedAt)
    ? allErrors.filter(e => e?.createdAt && new Date(e.createdAt) >= lastReprocessedAt)
    : allErrors

  const ftpError = process?.ftpError
  const totalErrors = errors.length + (ftpError ? 1 : 0)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      aria-labelledby='error-dialog-title'
    >
      <DialogTitle
        id='error-dialog-title'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ErrorOutlineIcon color='error' />
          <Typography variant='h6' component='span' fontWeight={600}>
            Dettaglio Errori
          </Typography>
          <Chip
            label={`${totalErrors} error${totalErrors !== 1 ? 'i' : 'e'}`}
            color='error'
            size='small'
            variant='outlined'
          />
        </Box>
        <IconButton onClick={onClose} size='small' aria-label='Chiudi'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2 }}>
        {totalErrors === 0 && (
          <Typography color='text.secondary' sx={{ py: 2, textAlign: 'center' }}>
            Nessun errore disponibile.
          </Typography>
        )}

        <Stack spacing={2}>
          {ftpError && (
            <Alert
              severity='warning'
              variant='outlined'
              sx={{ '& .MuiAlert-message': { width: '100%' } }}
            >
              <AlertTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography fontWeight={600} variant='body2'>
                  Errore Upload FTP
                </Typography>
                <Typography variant='caption' color='text.secondary'>
                  {ftpError.timestamp
                    ? DateTime.fromISO(ftpError.timestamp).toFormat('dd/MM/yyyy HH:mm')
                    : 'ND'}
                </Typography>
              </AlertTitle>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '120px 1fr',
                  rowGap: 0.75,
                  columnGap: 1.5,
                  alignItems: 'baseline',
                  fontSize: 13
                }}
              >
                <Typography variant='caption' fontWeight={600} color='text.secondary'>
                  Messaggio
                </Typography>
                <Typography variant='body2' sx={{ wordBreak: 'break-word' }}>
                  {ftpError.message || 'ND'}
                </Typography>
                <Typography variant='caption' fontWeight={600} color='text.secondary'>
                  Fonte
                </Typography>
                <Typography variant='body2'>
                  upload FTP/SFTP
                </Typography>
              </Box>
            </Alert>
          )}

          {errors.map((err, i) => {
            const date = err?.createdAt
              ? DateTime.fromISO(err.createdAt).toFormat('dd/MM/yyyy HH:mm')
              : 'ND'

            return (
              <Alert
                key={i}
                severity='error'
                variant='outlined'
                sx={{
                  '& .MuiAlert-message': { width: '100%' }
                }}
              >
                <AlertTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography fontWeight={600} variant='body2'>
                    Errore #{i + 1}
                  </Typography>
                  <Typography variant='caption' color='text.secondary'>
                    {date}
                  </Typography>
                </AlertTitle>

                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '120px 1fr',
                    rowGap: 0.75,
                    columnGap: 1.5,
                    alignItems: 'baseline',
                    fontSize: 13
                  }}
                >
                  <Typography variant='caption' fontWeight={600} color='text.secondary'>
                    Tipo Doc
                  </Typography>
                  <Typography variant='body2'>
                    {err?.docType || 'ND'}
                  </Typography>

                  <Typography variant='caption' fontWeight={600} color='text.secondary'>
                    Codice Errore
                  </Typography>
                  <Typography variant='body2'>
                    {err?.errorCode || 'ND'}
                  </Typography>

                  <Typography variant='caption' fontWeight={600} color='text.secondary'>
                    Messaggio
                  </Typography>
                  <Typography variant='body2' sx={{ wordBreak: 'break-word' }}>
                    {err?.errorMessage || 'ND'}
                  </Typography>

                  <Typography variant='caption' fontWeight={600} color='text.secondary'>
                    Fonte
                  </Typography>
                  <Typography variant='body2'>
                    {err?.source || 'ND'}
                  </Typography>
                </Box>
              </Alert>
            )
          })}
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 1.5 }}>
        <Button onClick={onClose} variant='outlined' size='small'>
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  )
}
